import React from "react";

const TechSection = () => (
  <section className="faqs" id="tech" aria-labelledby="tech-title">
    <div className="container">
      <div className="section-head">
        <span className="section-num">05</span>
        <h2 className="section-title" id="tech-title">
          Tech &amp; <em>access</em>.
        </h2>
      </div>

      <div className="faq-list">
        <details className="faq-item">
          <summary>Does 42courses have a mobile app?</summary>
          <div className="faq-answer">
            <p>
              No, and here's why we're not in a hurry to build one. The site is{" "}
              <strong>seriously mobile-friendly</strong>, works on any browser,
              any device, and your progress saves automatically as you go. Add
              it to your home screen and it behaves a lot like an app already.
            </p>
            <p>
              The reason we haven't built a native one is that humans mark your
              work, so you'd need a connection anyway to submit answers and get
              feedback. An offline app you can't actually pass on isn't much of
              an app. We keep an eye on it though.
            </p>
          </div>
        </details>

        <details className="faq-item">
          <summary>What languages are courses available in?</summary>
          <div className="faq-answer">
            <p>
              Course content is fully translated into{" "}
              <strong>
                English, Spanish, French, Hindi, Arabic and Portuguese
              </strong>
              . The instructor videos have English subtitles by default. If you
              want subtitles in another language, your browser's auto-translate
              handles this nicely.
            </p>
          </div>
        </details>

        <details className="faq-item">
          <summary>Is my data safe?</summary>
          <div className="faq-answer">
            <p>
              Yes. We're GDPR-compliant and never sell user data. Full details
              in our <a href="/privacy">privacy policy</a>.
            </p>
          </div>
        </details>
      </div>
    </div>
  </section>
);

export default TechSection;
